import React from 'react';

/**
 * Auth0-driven login screen. Renders a single "Log in" button that kicks off
 * the Auth0 universal login flow via @auth0/auth0-react.
 *
 * Props:
 *   onLogin — function bound to loginWithRedirect() in AuthGate
 *   error   — optional error message from the sync step
 */
export default function LoginScreen({ onLogin, error }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-slate-100">
      <div className="w-[400px] bg-slate-800 border border-slate-700 rounded-xl p-8 shadow-2xl text-center">
        <h1 className="text-2xl font-bold mb-1 bg-gradient-to-br from-indigo-500 to-purple-500 bg-clip-text text-transparent">
          Siphon
        </h1>
        <div className="text-slate-500 text-xs mb-6">Lead Intelligence for Alpha Level</div>

        {error && (
          <div className="text-red-400 text-xs mb-3 bg-red-500/10 border border-red-500/30 rounded p-2">
            {error}
          </div>
        )}

        <button
          onClick={onLogin}
          className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded py-3 hover:opacity-90"
        >
          Log in with Auth0
        </button>

        <div className="text-xs text-slate-500 mt-4">
          Authenticate with your Alpha Level account.
        </div>
      </div>
    </div>
  );
}
